import { render } from "./Elections.vue?vue&type=template&id=2018893e&scoped=true"
import script from "./Elections.vue?vue&type=script&lang=js"
export * from "./Elections.vue?vue&type=script&lang=js"

import "./Elections.vue?vue&type=style&index=0&id=2018893e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2018893e"]])

export default __exports__